import OnboardingWizard from '~/features/buyerProfile/onboarding/OnboardingWizard';

/** Route host for the Phase 2 investor onboarding wizard. */
export default function BuyerProfileOnboarding() {
  return <OnboardingWizard />;
}
